import {
  NpsSurveyResponseFields,
  NpsSurveyResponseMetaFields,
} from '../../../firebase/document-field.enums';
import { PlatformTypeEnum } from '../type/platform-type.enum';
import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';

export const NPS_SURVEY_RESPONSE_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: NpsSurveyResponseFields.user_name,
    label: 'surveyResponseList.tableFields.userName',
    placeholder: 'surveyResponseList.tableFields.userName',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: NpsSurveyResponseFields.nps_score,
    label: 'surveyResponseList.tableFields.npsScore',
    type: FilterType.slider,
    min: 1,
    max: 10,
    value: [1, 10],
    convertTo: 'number',
  },
  {
    fieldName: NpsSurveyResponseFields.platform,
    label: 'survey.platformType',
    placeholder: 'survey.platformType',
    type: FilterType.select,
    options: Object.values(PlatformTypeEnum).map((platform) => ({
      label: platform,
      value: platform,
    })),
    value: '',
  },
  {
    fieldName: NpsSurveyResponseFields.submitted_at_from,
    label: 'surveyResponseList.tableFields.submittedAtFrom',
    placeholder: 'surveyResponseList.tableFields.submittedAtFrom',
    type: FilterType.date_picker,
    value: '',
  },
  {
    fieldName: NpsSurveyResponseFields.submitted_at_to,
    label: 'surveyResponseList.tableFields.submittedAtTo',
    placeholder: 'surveyResponseList.tableFields.submittedAtTo',
    type: FilterType.date_picker,
    value: '',
  },
  {
    fieldName: NpsSurveyResponseMetaFields.app_version,
    label: 'common.appVersion',
    placeholder: 'common.appVersion',
    type: FilterType.select,
    options: [],
    value: '',
  },
  {
    fieldName: NpsSurveyResponseMetaFields.device_model,
    label: 'common.deviceModel',
    placeholder: 'common.deviceModel',
    type: FilterType.select,
    options: [],
    value: '',
  },
  {
    fieldName: NpsSurveyResponseMetaFields.os,
    label: 'common.osVersion',
    placeholder: 'common.osVersion',
    type: FilterType.select,
    options: [],
    value: '',
  },
];
